// In-page anchor smooth scroll. Adjust headerOffset if header is fixed.
export function initSmoothScroll({ headerOffset = 0 } = {}) {
  const getScrollPaddingTop = () => {
    const value = window.getComputedStyle(document.documentElement).scrollPaddingTop;
    const parsed = parseFloat(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  };

  document.querySelectorAll('a[href^="#"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      const href = a.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - getScrollPaddingTop();
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
}
